/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  VerifyEmail200,
  VerifyEmailRequest
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Verify email with a code sent to the user.
 *
 * On success, activates local records (user, org, teams where user is
 * admin) from ``pending`` to ``active``.  Does not authenticate — the
 * user must log in after verification.
 * @summary Verify Email
 */
export const verifyEmail = (
    verifyEmailRequest: VerifyEmailRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<VerifyEmail200>(
      {url: `/auth/verify-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyEmailRequest, signal
    },
      options);
    }




export const getVerifyEmailMutationKey = () => ['verifyEmail'] as const;

export const getVerifyEmailMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,VerifyEmailMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,VerifyEmailMutationVariables, TContext> => {

const mutationKey = getVerifyEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmail>>, VerifyEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifyEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmail>>>
    export type VerifyEmailMutationBody = VerifyEmailRequest
    export type VerifyEmailMutationError = HTTPValidationError
    export type VerifyEmailMutationVariables = {data: VerifyEmailRequest}

    /**
 * @summary Verify Email
 */
export const useVerifyEmail = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,VerifyEmailMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmail>>,
        TError,
        VerifyEmailMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyEmailMutationOptions(options));
    }
